/* Native forms remain functional without JavaScript. No cart request is intercepted. */
(() => {
  'use strict';
  const dialogOpeners = new WeakMap();
  const init = () => {
    const root = document.querySelector('body.rb');
    if (!root) return;
    root.classList.add('rb-enhanced');
    const strings = JSON.parse(document.getElementById('rb-linen-strings')?.textContent || '{}');
    const announce = text => { const status = document.querySelector('[data-rb-status]'); if (status) status.textContent = text; };
    root.querySelectorAll('[data-rb-product]').forEach(surface => {
      if (surface.dataset.rbReady) return;
      surface.dataset.rbReady = 'true';
      const update = (control, notify) => {
        const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        if (!option || option.disabled) return;
        const money = option.dataset.money;
        const label = option.dataset.label;
        surface.querySelectorAll('[data-rb-price]').forEach(p => {
          const currency = p.querySelector('span')?.cloneNode(true);
          p.replaceChildren(document.createTextNode(money + ' '));
          if (currency) p.append(currency);
        });
        const mobilePrice = surface.querySelector('[data-rb-mobile-price]');
        if (mobilePrice) mobilePrice.textContent = money;
        const box = surface.querySelector('.rb-box-selection > span:last-child, .rb-product__box')?.textContent || '';
        const mobileFinish = surface.querySelector('[data-rb-mobile-finish]');
        if (mobileFinish) mobileFinish.textContent = label + ' · ' + box;
        if (surface.hasAttribute('data-rb-pdp')) {
          const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
          surface.querySelectorAll('[data-rb-add]').forEach(b => { b.disabled = option.dataset.available !== 'true'; });
        }
        if (notify) announce((strings.finishStatus || '').replace('__FINISH__', label).replace('__PRICE__', money).replace('__BOX__', box));
      };
      surface.querySelectorAll('[data-rb-variant]').forEach(c => c.addEventListener('change', () => { if (c.tagName === 'SELECT' || c.checked) update(c, true); }));
      const initial = surface.querySelector('input[data-rb-variant]:checked, select[data-rb-variant]');
      if (initial) update(initial, false);
    });
    const controls = dialog => [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.getClientRects().length);
    const open = (dialog, trigger) => { if (!dialog || dialog.open) return; dialogOpeners.set(dialog, trigger); dialog.showModal(); document.documentElement.classList.add('rb-dialog-open'); controls(dialog)[0]?.focus({preventScroll:true}); };
    root.querySelectorAll('[data-card-dialog], [data-image-dialog]').forEach(dialog => {
      if (dialog.dataset.rbReady) return; dialog.dataset.rbReady = 'true';
      dialog.addEventListener('keydown', e => {
        if (e.key !== 'Tab') return; const els = controls(dialog), first = els[0], last = els[els.length - 1];
        if (!els.length) { e.preventDefault(); return; }
        if (e.shiftKey && (document.activeElement === first || !els.includes(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !els.includes(document.activeElement))) { e.preventDefault(); first.focus(); }
      });
      dialog.querySelectorAll('[data-close-dialog]').forEach(b => b.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('rb-dialog-open');
        const trigger = dialogOpeners.get(dialog);
        requestAnimationFrame(() => {
          if (!dialog.open && trigger?.isConnected && !root.querySelector('[data-card-dialog][open], [data-image-dialog][open]')) trigger.focus({preventScroll:true});
        });
      });
    });
    root.querySelectorAll('[data-read-card]').forEach(button => {
      if (button.dataset.rbReady) return; button.dataset.rbReady = 'true';
      button.addEventListener('click', event => open(root.querySelector('[data-card-dialog]'), event.currentTarget));
    });
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.rbReady) return; gallery.dataset.rbReady = 'true';
      const image = gallery.querySelector('.rb-gallery-image'), thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      if (!image || !thumbs.length) return;
      let selected = 0, animation;
      const select = index => {
        selected = (index + thumbs.length) % thumbs.length; const thumb = thumbs[selected];
        image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = thumb.dataset.src; image.alt = thumb.dataset.alt;
        animation?.cancel();
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) image.decode().then(() => { if (thumb === thumbs[selected]) animation = image.animate([{opacity:.72},{opacity:1}], {duration:180,easing:'ease-out'}); }).catch(() => {});
        thumbs.forEach((t,i) => { if(i === selected)t.setAttribute('aria-current','true');else t.removeAttribute('aria-current'); });
        const counter = gallery.querySelector('[data-gallery-counter]'); if(counter) counter.textContent = String(selected+1).padStart(2,'0') + ' / ' + String(thumbs.length).padStart(2,'0');
        announce((strings.imageStatus || '').replace('__CURRENT__',selected+1).replace('__TOTAL__',thumbs.length).replace('__ALT__',image.alt));
      };
      thumbs.forEach((thumb,index) => {
        thumb.addEventListener('click',e => { e.preventDefault();select(index); });
        thumb.addEventListener('keydown',e => { if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();select(e.key==='Home'?0:e.key==='End'?thumbs.length-1:selected+(e.key==='ArrowRight'?1:-1));thumbs[selected].focus(); });
      });
      gallery.querySelector('[data-zoom-image]')?.addEventListener('click',event => {
        const dialog=root.querySelector('[data-image-dialog]'), enlarged=dialog?.querySelector('[data-enlarged-image]');
        if(!enlarged)return;enlarged.src=thumbs[selected].dataset.large;enlarged.alt=image.alt;open(dialog,event.currentTarget);
      });
    });
    root.querySelectorAll('img[src]').forEach(image => {
      if(image.dataset.rbReady)return;image.dataset.rbReady='true';
      const fallback=()=>{if(image.dataset.failed)return;image.dataset.failed='true';const text=document.createElement('span');text.className='rb-image-fallback';text.textContent=strings.imageUnavailable || image.alt;image.hidden=true;image.after(text);};
      image.addEventListener('error',fallback);if(image.complete && !image.naturalWidth)fallback();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
